/** CUSTOMIZATIONS:
- configurato la popupContent per i tipi di contenuto luogo con data di fine
- aggiunta condizione nel onMarkerClick per permettere di aprire la popup nel caso del luogo o andare direttamente al CT
- configurato nuovo pin iconWarning per gli avvisi dei luoghi con scadenza
*/

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import cx from 'classnames';
import { OSMMap } from 'volto-venue';
import { Row, Col, Container } from 'design-react-kit';
import {
  ListingLinkMore,
  Icon,
} from 'design-comuni-plone-theme/components/ItaliaTheme';
import { List, ListItem } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';
import { viewDate } from 'design-comuni-plone-theme/helpers';
import { UniversalLink } from '@plone/volto/components';
import ReactDOMServer from 'react-dom/server';
import iconWarning from 'provincia-varese-theme/components/layout/images/warning-icon.svg';

const messages = defineMessages({
  default_detail_link: {
    id: 'Vedi',
    defaultMessage: 'Vedi',
  },
  no_markers: {
    id: 'Non ci sono punti da mostrare sulla mappa',
    defaultMessage: 'Non ci sono punti da mostrare sulla mappa',
  },
  hour_from_map_popup: {
    id: 'Dal',
    defaultMessage: 'Dal',
  },
  hour_to_map_popup: {
    id: 'Fino al',
    defaultMessage: 'Fino al',
  },
});

const MapTemplate = ({
  items,
  isEditMode,
  linkAlign,
  linkTitle,
  linkHref,
  title,
  titleLine,
  show_map_full_width,
  map_size = 'medium',
  linkmore_id_lighthouse,
}) => {
  const intl = useIntl();
  let history = useHistory();

  moment.locale(intl.locale);

  const [markers, setMarkers] = useState([]);

  //  Create the Icon
  const LeafIcon = (options, item) => {
    return {
      html: ReactDOMServer.renderToString(
        // used from map
        <img
          src={options.iconUrl}
          alt={item.title}
          width={options.iconSize[0]}
          height={options.iconSize[1]}
        />,
      ),
      ...options,
    };
  };

  useEffect(() => {
    let points = items
      .filter(
        (item) =>
          (item.latitude &&
            item.longitude &&
            item.latitude !== 0 &&
            item.longitude !== 0) ||
          (item.geolocation && //for backward compatibility. To remove on next release.
            item.geolocation?.latitude &&
            item.geolocation?.longitude &&
            item.geolocation?.latitude !== 0 &&
            item.geolocation?.longitude !== 0),
      )
      .map((item) => {
        return {
          title: item.title,
          description: item.description ?? null,
          popupContent: (
            <List bulleted className="list-results">
              {item.title && (
                <UniversalLink
                  className="title"
                  href={flattenToAppURL(item['@id'])}
                >
                  {item?.title?.split(' - ')[0]?.trim() || ''}
                </UniversalLink>
              )}
            </List>
          ),
          ...(item.end &&
            item['@type'] === 'Venue' && {
              divIcon: LeafIcon(
                {
                  iconUrl: iconWarning,
                  iconSize: [30, 41],
                  iconAnchor: [12.5, 20.5],
                  className: '',
                },
                item,
              ),
              popupContent: (
                <div>
                  {/* Title description and link */}
                  <UniversalLink
                    className="fw-bold text-primary"
                    href={history.push(item['@id'])}
                  >
                    {item.title}
                  </UniversalLink>
                  {item?.description && (
                    <p className="mt-0">{item.description}</p>
                  )}

                  {/* Added start and close info venue */}
                  {(item?.start || item?.end) && (
                    <div className="d-flex">
                      <Icon color="black" size="sm" icon="it-calendar" />
                      <div className="flex-column ms-2">
                        {item?.start && (
                          <span>
                            {intl.formatMessage(messages.hour_from_map_popup)}{' '}
                            {viewDate(
                              intl.locale,
                              item.start,
                              'DD/MM/Y, HH:MM',
                            )}
                          </span>
                        )}
                        <br />
                        {item?.end && (
                          <span>
                            {intl.formatMessage(messages.hour_to_map_popup)}{' '}
                            {viewDate(intl.locale, item.end, 'DD/MM/Y, HH:MM')}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ),
            }),
          ...(item.geolocation
            ? item.geolocation
            : { latitude: item.latitude, longitude: item.longitude }),
        };
      });

    setMarkers(points);
  }, [items]);

  return (
    <div className="map-template">
      <Container className="px-4">
        {title && (
          <Row>
            <Col>
              <h2 className={cx('mb-4', { 'title-bottom-line': titleLine })}>
                {title}
              </h2>
            </Col>
          </Row>
        )}
        {items?.length > 0 && markers?.length > 0 ? (
          <Row
            className={cx('mb-4 map-wrapper', {
              'full-width': show_map_full_width,
              ['size_' + map_size]: map_size,
            })}
          >
            <OSMMap
              zoom={15}
              markers={markers}
              showPopup={true}
              mapOptions={{
                scrollWheelZoom: false,
                // tap: false,
                // dragging: false,
              }}
            />
          </Row>
        ) : (
          intl.formatMessage(messages.no_markers)
        )}

        <ListingLinkMore
          title={linkTitle}
          href={linkHref}
          linkAlign={linkAlign}
          className="my-5"
          linkmoreIdLighthouse={linkmore_id_lighthouse}
        />
      </Container>
    </div>
  );
};

MapTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
};

export default MapTemplate;
